export const openWindowsWindow = (params) => {
    return new Promise((resolve) => {
        const options = Windows.Security.Authentication.Web.WebAuthenticationOptions.none;
        const requestUri = new Windows.Foundation.Uri(params.requestUri);
        const callbackUri = new Windows.Foundation.Uri(params.redirectUri);

        // Opens a window and completes the authentication process
        // Note that callbackUri is not called - this function returns when it is hit.
        Windows.Security.Authentication.Web.WebAuthenticationBroker.authenticateAsync(
            options,
            requestUri,
            callbackUri
        ).done(
            (result) => {
                if (result.responseData == '') {
                    resolve({ error: 'An error has occurred.', redirectUrl: null });
                } else {
                    resolve({ error: null, redirectUrl: result.responseData });
                }
            },
            (err) => {
                resolve({ error: err, redirectUrl: null });
            }
        );
    });
};
